import Notiflix from "notiflix";
import { useCallback, useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

//ANT DESIGN IMPORTS
import { Card, Col, Collapse, Form, Input, Layout, Row, Select, Spin, Typography } from "antd";

//PROJECT IMPORTS
import TopContent from "../../../components/layouts/TopContent";
import appLabel from "../../../config/appLabel";
import appStatic from "../../../config/appStatic";
import definedApi from "../../../services/definedApi";
import cnt from "../../../services/definedConstant";
import { BOM } from "../../../services/definedMethod";

import "../../../assets/styles/DatePicker.css";
import MainLayout from "../../../components/layouts/MainLayout";
import RecordStatus from "../../../components/RecordStatus";
import { showCheckerApprovalModal } from "../../../components/CheckerModal";
import GlOverview from "./components/view/GlOverview";
import { labelConfig, staticConfig } from "../glAndAccounting.config";
import CurrencyConfig from "./components/view/CurrencyConfig";
import PostingControls from "./components/view/PostingControls";
import BalanceManagement from "./components/view/BalanceManagement";
import ReconcilationAndControl from "./components/view/ReconcilationAndControl";

const { Content } = Layout;
const { Text, Title } = Typography;
const { Panel } = Collapse;

const ViewCST0100Demo = (props) => {
  //DECLARED VARIABLES
  const { userData, rightBtn } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { state } = useLocation();
  const [useForm] = Form.useForm();
  const [glDetail, setGlDetail] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [parentData, setParentData] = useState([]);
  const [accountTypeId, setAccountTypeId] = useState([]);
  const [accountTypeData, setAccountTypeData] = useState([]);
  const [glAccTemplate, setGlAccTemplate] = useState({});
  const [accountTagData, setAccountTagData] = useState([]);
  const [activeTabKey, setActiveTabKey] = useState("overview");
  const [activeDisableState, setActiveDisableState] = useState(null);

  useEffect(() => {
    getTemplate();
    getDetailById(state);
  }, []);

  const getDetailById = (params) => {
    setIsLoading(true);

    const url = `${definedApi.GlAccount}/${params.key}`;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;
        setGlDetail(objDetail);

        switch (params.disabled) {
          case true:
            dispatch({
              type: BOM.HasPermission("UPDATE_GLACCOUNT") && cnt.RIGHT_APPROVE_BTN,
            });
            break;

          default:
            dispatch({
              type: BOM.HasPermission("UPDATE_GLACCOUNT") && cnt.RIGHT_REJECT_BTN,
            });
            break;
        }
        if (objDetail?.usage?.value.toLowerCase() === "header") {
          dispatch({
            type: BOM.HasPermission("CREATE_GLACCOUNT") && cnt.RIGHT_ADD_BTN,
          });
        }
        // if (BOM.HasPermission("DELETE_GLACCOUNT")) {
        //   dispatch({
        //     type: cnt.RIGHT_DELETE_BTN,
        //   });
        // }

        useForm.setFieldsValue({
          parentId: objDetail?.parentId,
          tagId: objDetail?.tagId?.id === 0 ? undefined : objDetail?.tagId?.id,
          description: objDetail?.description,
        });

        setAccountTypeId(objDetail?.type?.id);
        setActiveDisableState(objDetail?.disabled);
        setIsLoading(false);
      }
    });
  };

  function getTemplate() {
    let body = {
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, definedApi.GlAccountTemplate, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
        setIsLoading(false);
      } else {
        const objList = res;
        setGlAccTemplate(res);

        let tempAccountType = [];

        objList?.accountTypeOptions?.forEach((element) => {
          tempAccountType.push({
            value: element.id,
            label: element.value,
          });
        });

        setAccountTypeData(tempAccountType);
        setIsLoading(false);
      }
    });
  }

  const getOptionsFromTemplate = (templateKey) => {
    if (!glAccTemplate[templateKey]) return [];

    return glAccTemplate[templateKey].map((element) => ({
      value: element.id,
      label: element.name,
    }));
  };

  const updateParentAndTagData = useCallback(
    (accountTypeId) => {
      const accountTypeOption = accountTypeData.find((option) => option.value === accountTypeId);

      if (!accountTypeOption) return;

      const accountTypeLabel = accountTypeOption.label.toLowerCase();

      let parentOptions = [];
      let tagOptions = [];

      switch (accountTypeLabel) {
        case "asset":
          parentOptions = getOptionsFromTemplate("assetHeaderAccountOptions");
          tagOptions = getOptionsFromTemplate("allowedAssetsTagOptions");
          break;
        case "liability":
          parentOptions = getOptionsFromTemplate("liabilityHeaderAccountOptions");
          tagOptions = getOptionsFromTemplate("allowedLiabilitiesTagOptions");
          break;
        case "equity":
          parentOptions = getOptionsFromTemplate("equityHeaderAccountOptions");
          tagOptions = getOptionsFromTemplate("allowedEquityTagOptions");
          break;
        case "expense":
          parentOptions = getOptionsFromTemplate("expenseHeaderAccountOptions");
          tagOptions = getOptionsFromTemplate("allowedExpensesTagOptions");
          break;
        case "income":
          parentOptions = getOptionsFromTemplate("incomeHeaderAccountOptions");
          tagOptions = getOptionsFromTemplate("allowedIncomeTagOptions");
          break;
        default:
          parentOptions = getOptionsFromTemplate("assetHeaderAccountOptions");
          tagOptions = getOptionsFromTemplate("allowedAssetsTagOptions");
          break;
      }

      setParentData(parentOptions);
      setAccountTagData(tagOptions);
    },
    [accountTypeData],
  );

  useEffect(() => {
    updateParentAndTagData(accountTypeId);
  }, [accountTypeId, updateParentAndTagData]);

  function handleOnCreate() {
    const { addBtn } = rightBtn;
    if (addBtn.toLowerCase() === "primary") {
      navigate("/add-subledger-gla0100", { state: state });
    } else {
      console.log("Could not open the link");
    }
  }

  const onApproveReject = (key) => {
    // console.log("key: ", key);
    const url = `${definedApi.ApproveReject}/${state.key}`;

    let action = "";
    let label = state.account;
    let criteria = "";

    switch (key?.toLowerCase()) {
      case "approve":
        action = "Approve ";
        criteria = false;
        break;
      default:
        action = "Reject ";
        criteria = true;
        break;
    }

    let body = {
      method: "PUT",
      disabled: criteria,
      session,
    };

    // console.log(body);return

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",
      function () {
        // Yes
        // BOM.LoadAlert(cnt.LOAD, "Processing");
        setIsLoading(true);
        BOM.FetchReqAction(
          body,
          url,
          (err, res) => {
            if (err) {
              BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
            } else {
              BOM.AlertMsg(cnt.SUCCESS, BOM.handleSuccessMsg(`${state.account} account `));
              navigate("/gla0100");
            }
          },
          {
            navigate,
            showCheckerModal: showCheckerApprovalModal,
            onCheckerApproval: (res) => {
              navigate("/gla0100");
              setIsLoading(false);
            },
          },
        );
      },
      function () {},
    );
  };

  const handleOnDelete = () => {
    let action = "Close  ";
    let label = state.account;
    // console.log(body);return

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",
      function () {
        // Yes
        const url = `${definedApi.GlAccount}/${state.key}`;

        const body = {
          method: "DELETE",
          session,
        };

        setIsLoading(true);

        BOM.FetchReqAction(
          body,
          url,
          (err, res) => {
            if (err) {
              BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
              setIsLoading(false);
            } else {
              BOM.AlertMsg(cnt.SUCCESS, appLabel.deleteGlAccountMsg);
              navigate("/gla0100");
              //STOP LOAD
              setIsLoading(false);
            }
          },
          {
            navigate,
            showCheckerModal: showCheckerApprovalModal,
            onCheckerApproval: (res) => {
              navigate("/gla0100");
              setIsLoading(false);
            },
          },
        );
      },
      function () {},
    );
  };

  const tabList = [
    {
      key: "overview",
      label: "General Ledger Overview",
      // disabled: !BOM.HasPermission("READ_CLIENT"),
    },
    {
      key: "currencyConfig",
      label: "Currency Configuration",
      // disabled: !BOM.HasPermission("READ_CLIENT"),
    },
    {
      key: "postingControls",
      label: "Posting Controls",
      // disabled: !BOM.HasPermission("READ_ADDRESS"),
    },
    {
      key: "balanceManagement",
      label: " Balance Management",
      // disabled: !BOM.HasPermission("READ_ADDRESS"),
    },
    {
      key: "reconciliationControl",
      label: "Reconciliation & Control",
      // disabled: !BOM.HasPermission("READ_ADDRESS"),
    },
  ];
  const contentListNoTitle = {
    overview: <GlOverview glDetail={glDetail} />,
    currencyConfig: <CurrencyConfig glDetail={glDetail} />,
    postingControls: <PostingControls glDetail={glDetail} />,
    balanceManagement: <BalanceManagement glDetail={glDetail} />,
    reconciliationControl: <ReconcilationAndControl glDetail={glDetail} />,
  };

  const onTabChange = (key) => {
    // console.log(key);
    setActiveTabKey(key);
  };

  return (
    <MainLayout
      isEnableRightSidebar={true}
      onApprove={() => onApproveReject("approve")}
      onReject={() => onApproveReject("reject")}
      onAdd={handleOnCreate}
      // onDelete={handleOnDelete}
    >
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent pageTitle={labelConfig.glDetail} pageItems={staticConfig.detailGLItems} />

      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            width: "100%",
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
          tabList={tabList}
          activeTabKey={activeTabKey}
          onTabChange={onTabChange}
          tabProps={{
            size: "middle",
          }}
        >
          {contentListNoTitle[activeTabKey]}
        </Card>

        {/* PART 3 DISPLAY  RECORD STATUS */}
        <RecordStatus authStatus={""} makerID={""} makerDate={""} checkerID={""} checkerDate={""} />
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ViewCST0100Demo);
